import { Trans, useTranslation } from "@coworker/locales";
import {
  useGivenName,
  useTeamId,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { EnvironmentTag } from "@coworker/app/src/components/EnvironmentTag";
import { QuickActions } from "../QuickActions/QuickActions";
import { TasksPreview } from "../TasksPreview/TasksPreview";
import styles from "./home-page.module.css";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import { DiscoverNow } from "../DiscoverNow/DiscoverNow";
import { useMyStore } from "@coworker/app/src/core/auth/useLoggedInUser";
import { ProductQualityError } from "../../../shared/components/ProductQualityError/productQualityError";
import { useState, useEffect } from "react";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { FixaWindow } from "@coworker/reusable/helpers/devices";

export const HomePage = () => {
  const teamId = useTeamId();
  const navigate = useFixaNavigate();

  useEffect(() => {
    // This effect runs only once when the component mounts
    if (!teamId) {
      navigate("/teamselection", { replace: true });
    }
  }, [teamId, navigate]);

  const [openErrorModal, setOpenErrorModal] = useState(false);
  const store = useMyStore();
  const firstname = useGivenName();

  return (
    <div className={styles["home-outer-container"]}>
      <div className={styles["home-container"]}>
        <div className={styles["vertical-center"]}>
          <FixaText textStyle="Heading.L" tagName="h2">
            {<Trans>hejString</Trans>} {firstname},
            {store?.storeId && store?.name && (
              <FixaText tagName="p" textStyle="Body.M">
                {store.storeId} - {store.name}
              </FixaText>
            )}
          </FixaText>
          <EnvironmentTag />
        </div>
        <div className={styles["quick-actions-container"]}>
          <QuickActions
            id="quickActionsHome"
            setOpenProductQualityErrorModal={setOpenErrorModal}
          />
        </div>
        <ProductQualityError
          openProductQualityErrorModal={openErrorModal}
          onClose={setOpenErrorModal}
        />
        {(window as FixaWindow).enableDiscoverNow && <DiscoverNow />}
        <TasksPreview />
      </div>
    </div>
  );
};
